const Shared = {

    assets: "../assets/canine-u",

    key: {
        refresh: "refresh",
        token: "token",
        user: "user"
    },

    path: {
        login: "/canine-u",
        catalog: "/canine-u/catalog",
        register: "/canine-u/register",
        schedule: "/canine-u/schedule",
        map: "/canine-u/map",
        faculty: "/canine-u/faculty",
        menu: "/canine-u/menu"
    },

    semesters: [
        "Fall",
        "Spring",
        "Summer"
    ],

    removeSession: function () {

        console.log("removing session data");
        sessionStorage.removeItem(this.key.token);
        sessionStorage.removeItem(this.key.user);
    },
}

export default Shared;